module.exports = __webpack_public_path__ + "media/images/btn_see_bookings_as_cover_station-ce1dd2591cb9127f5d3edfcf9530c7d1.gif";